import React from 'react';
import { Navigate } from 'react-router-dom';
import MessageModal from '../modals/MessageModal';
import AlertModal from '../modals/AlertModal';
import PasswordModal from '../modals/PasswordModal';
import './SitePage.css';
import './CreateCommunityPage.css';
import { Server } from 'src/server/server';
import { BsCaretDownFill, BsFillPencilFill, BsXLg } from 'react-icons/bs';
import { AppConfig } from '../AppConfig';
import PageEnvelope from '../elements/PageEnvelope';

let COMMUNITY_VERSION = 1;

interface CreateCommunityPageState {
  // form
  name: string;
  slug: string;
  font: number
  palette: number;
  icon: number;
  // options
  customSlug: boolean;
  icons: string[],
  showPalettes: boolean;
  showFonts: boolean,
  // system
  message: string;
  alert: string;
  navigate: string;
}

class CreateCommunityPage extends React.Component<{}, CreateCommunityPageState> {
  constructor(props:{}) {
    super(props);
    this.state = {
      name: '',
      slug: '',
      font: 0,
      palette: 0,
      icon: 0,
      customSlug: false,
      icons: [],
      showFonts: false,
      showPalettes: false,
      message: '',
      alert: '',
      navigate: ''
    }
  }

  componentDidMount() {
    this.shuffleIcons();
  }

  shuffleIcons() {
    let icons = [...AppConfig.icons];

    for(let i = 0; i < icons.length; i++) {
      let r1 = Math.floor(Math.random() * icons.length);
      let r2 = Math.floor(Math.random() * icons.length);
      let temp = icons[r1];
      icons[r1] = icons[r2];
      icons[r2] = temp;
    }

    while(icons.length > 12) {
      let r = Math.floor(Math.random() * icons.length);
      icons.splice(r, 1);
    }

    this.setState({icons, icon: 0});
  }

  setSlugBasedOnName(name:string) {
    let noSpecial = name.replace(/[^a-zA-Z0-9 ]/, '');
    let words = noSpecial.match(/\w+/g);
    let slug = words ? words.join('') : '';
    slug = slug.toLowerCase();
    this.setState({slug})
  }

  onNameChange(e:any): void {
    let value = e.currentTarget.value;
    this.setState({name: value});

    if(!this.state.customSlug)
      this.setSlugBasedOnName(value);
  };

  onSlugChange(e:any) {
    if(!this.state.customSlug)
      return;
    this.setState({slug: e.currentTarget.value})
  }

  onCancelEditSlug() {
    this.setSlugBasedOnName(this.state.name);
    this.setState({customSlug: false});
  }

  onFont(fi:number) {
    this.setState({font: fi, showFonts: false});
  }

  onPalette(ti:number) {
    this.setState({palette: ti, showPalettes: false})
  }

  onCreate() {
    if(this.state.name == '') {
      this.setState({alert: 'Please enter a name for the community.'});
      return;
    }

    this.createCommunity();
  }

  createCommunity() {
    this.setState({message: 'Creating community...'});

    setTimeout(async () => {
      let palette = AppConfig.palettes[this.state.palette];
      let styles = {...AppConfig.styles};
      styles['body-font'] = AppConfig.fonts[this.state.font];

      let params:any = {
        slug: this.state.slug, 
        name: this.state.name, 
        icon: this.state.icons[this.state.icon],
        theme: {palette, styles},
        description: '',
        public: false,
        version: COMMUNITY_VERSION
      }

      let response = await Server.user.createCommunity(params);
  
      if (response.success) {
        // let host = window.location.host;
        // if(host.indexOf('www.') == 0)
        //   host = host.replace('www.', this.state.slug + '.');
        // else
        //   host = this.state.slug + '.' + host;
        // let url = `${window.location.protocol}//${host}`;
        // window.open(url, '_blank');
        // this.setState({message: ''});
        Server.user.addCommunityToCache({id: response.id, role: 'admin'});
        this.setState({message: '', navigate: '/dashboard'});
      }
      else
        this.setState({message: '', alert: response.message})
    }, 500);
  }

  renderFontsDropdown() {
    let divs = [];
    for(let i = 0; i < AppConfig.fonts.length; i++) {
      divs.push(
        <div 
          key={i}
          style={{borderRadius: '6px', fontFamily: AppConfig.fonts[i]}}
          onClick={()=>this.onFont(i)}
        >
          {AppConfig.fonts[i]}
        </div>
      )
    }

    return (
      <div>
        <div className="site-page-dropdown" style={{top: '40px', left: '0px'}}>
          <div style={{display: 'flex', flexDirection: 'column', rowGap: '10px', margin: '10px'}}>
            {divs}
          </div>
        </div>
        <div className="site-page-dropdown-modal" />
      </div>
    )
  }

  renderFonts() {
    return (
      <div style={{display: 'grid', gridTemplateColumns: '1fr 45px'}}>
        <div 
          className="create-community-page-font" 
          style={{fontFamily: AppConfig.fonts[this.state.font], position: 'relative'}}
          onClick={()=>this.setState({showFonts: !this.state.showFonts})}
        >
          {AppConfig.fonts[this.state.font]}
          {this.state.showFonts && this.renderFontsDropdown()}
        </div>
        <button 
          className="site-page-icon-button" 
          style={{marginLeft: '5px'}} 
          onClick={()=>this.setState({showFonts: !this.state.showFonts})}
        >
          <BsCaretDownFill/>
        </button>
      </div>
    )
  }

  renderPaletteColors(ti:number) {
    let colorDivs = [];
    for(let j = 0; j < AppConfig.palettes[ti].length; j++) {
      colorDivs.push(
        <div 
          key={j} 
          style={{
            backgroundColor: AppConfig.palettes[ti][j],
            flex: '1'
          }} 
        />
      )
    }

    return(
      <div 
        key={ti}
        style={{width: '100%', overflow: 'hidden', borderRadius: '6px', padding: '0px', display: 'flex', flexDirection: 'column', border: '1px solid #00000020'}}
        onClick={()=>this.onPalette(ti)}
      >
        <div style={{height: '30px', display: 'flex', flexDirection: 'row'}}>
          {colorDivs}
        </div>
      </div>
    )
  }

  renderColorsDropdown() {
    let divs = [];
    for(let i = 0; i < AppConfig.palettes.length; i++) {
      divs.push(
        <div 
          key={i}
          style={{borderRadius: '6px'}}
          onClick={()=>this.onPalette(i)}
        >
          {this.renderPaletteColors(i)}
        </div>
      )
    }

    return (
      <div>
        <div className="site-page-dropdown" style={{top: '40px', left: '0px'}}>
          <div style={{display: 'flex', flexDirection: 'column', rowGap: '10px', margin: '10px'}}>
            {divs}
          </div>
        </div>
        <div className="site-page-dropdown-modal" />
      </div>
    )
  }

  renderColors() {
    return (
      <div style={{display: 'grid', gridTemplateColumns: '1fr 45px'}}>
        <div 
          className="create-community-page-colors" 
          style={{position: 'relative'}}
          onClick={()=>this.setState({showPalettes: !this.state.showPalettes})}
        >
          {this.renderPaletteColors(this.state.palette)}
          {this.state.showPalettes && this.renderColorsDropdown()}
        </div>
        <button 
          className="site-page-icon-button" 
          style={{marginLeft: '5px'}}
          onClick={()=>this.setState({showPalettes: !this.state.showPalettes})}
        >
          <BsCaretDownFill/>
        </button>
      </div>
    )
  }

  renderIcons() {
    let iconDivs = [];
    for(let i = 0; i < this.state.icons.length; i++) {
      let style = null;
      if(i == this.state.icon)
        style = {borderColor: 'var(--input-border-color)'};

      iconDivs.push(
        <img style={style} key={i} src={this.state.icons[i]} onClick={()=>this.setState({icon: i})}></img>
      )
    }

    return (
      <div className="create-community-page-icons">
        {iconDivs}
      </div>
    )
  }

  render() {
    if(this.state.navigate != '')
      return <Navigate to={this.state.navigate} />

    return (
      <div className="site-page">
        <PageEnvelope width="500px">
          <div style={{textAlign: 'center', margin: '0px 0px 20px 0px'}}>
            Use this form to create a new community.
          </div>
          <div className="site-page-panel">
            <div className="create-community-page-input-row">
              <div>Name</div>
              <input value={this.state.name} onChange={(e:any)=>this.onNameChange(e)}></input>
            </div>
            <div className="create-community-page-input-row">
              <div>Subdomain</div>
              <div style={{display: 'grid', gridTemplateColumns: '1fr 45px'}}>
                <input disabled={!this.state.customSlug} value={this.state.slug} onChange={(e:any)=>this.onSlugChange(e)}></input>
                {!this.state.customSlug ?
                  <button 
                    className="site-page-icon-button" 
                    style={{marginLeft: '5px'}}
                    onClick={()=>this.setState({customSlug: true})}
                  >
                    <BsFillPencilFill/>
                  </button> :
                  <button 
                    className="site-page-icon-button" 
                    style={{marginLeft: '5px'}}
                    onClick={()=>this.onCancelEditSlug()}
                  >
                    <BsXLg/>
                  </button> 
                }
              </div>
            </div>
            <div className="create-community-page-input-row" style={{marginTop: '-10px'}}>
              <div style={{fontSize: '0.9em', color: '#000000bb', marginLeft: '10px'}}>
                {this.state.slug == '' ? 'slug' : this.state.slug}.oneclick.community
              </div>
            </div>
            <div className="create-community-page-input-row">
              <div>Font</div>
              {this.renderFonts()}
            </div>
            <div className="create-community-page-input-row">
              <div>Colors</div>
              {this.renderColors()}
            </div>
            <div className="create-community-page-input-row" style={{marginTop: '5px'}}>
              <div className="create-community-page-icon-header">
                <div>Icon</div>
                <div 
                  style={{fontSize: '0.8em', cursor: 'pointer', color: '#000000bb'}}
                  onClick={()=>this.shuffleIcons()}
                >
                  <u>more</u>
                </div>
              </div>
              {this.renderIcons()}
              <div style={{fontSize: '0.8em', color: '#000000bb', textAlign: 'center', marginTop: '5px'}}>
                <i>Custom fonts, colors, icon, and logo can be defined in the community settings after it is created.</i>
              </div>
            </div>
            <div className="site-page-button-bar">
              <button onClick={()=>this.onCreate()}>Create Community</button>
            </div>
          </div>
        </PageEnvelope>
        <MessageModal message={this.state.message}/>
        <AlertModal message={this.state.alert} button="OK" onClose={()=>this.setState({alert: ''})} />
      </div>
    );
  }
}

export default CreateCommunityPage;